import { Injectable } from '@angular/core';
import {
  ProductListOutput,
  ProductType,
} from 'frontend.client.api';
import { BehaviorSubject } from 'rxjs';
import { PartnerStateService } from '../shared/partner-state.service';

interface ProductsState {
  productList: ProductListOutput[];
  loading: boolean;
  error: Error | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private subFolder: string | undefined;
  private productListState$ = new BehaviorSubject<ProductsState>({
    loading: true,
    productList: [],
    error: undefined,
  });

  constructor(
    private partnerStateService: PartnerStateService,
  ) {
    this.partnerStateService.partnerState.subscribe((partner) => {
      this.subFolder = partner?.subFolder;
      if (partner?.partnerData?.products) {
        this.productListState.next({
          productList: partner?.partnerData?.products ?? [],
          loading: false,
          error: undefined,
        })
      } else {
        this.productListState.next({
          productList: [],
          loading: false,
          error: {
            name: 'Error',
            message: 'Unable to load products',
          },
        })
      }
    });
  }

  public get productListState() {
    return this.productListState$;
  }

  public getDeliveryTime(productType: ProductType) {
    const product = this.productListState$
      .getValue()
      .productList.find((prod) => prod.productType === productType);

    if (!product) return '';

    switch (product.deliveryTime) {
      case 'MULTIPLE_WEEKS':
        return 'Lieferung innerhalb von mehreren Wochen';
      case 'ONE_TO_TWO_DAYS':
        return 'Lieferung innerhalb von 1-2 Werktagen';
    }
  }
}
